var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<dl ng-repeat=\"key in vm.param_keys\" class=\"dl-horizontal\"><dt>{{ vm.parameter[vm.key].wert[key].bez }}:</dt><dd><parametermodule parameter=\"vm.parameter[vm.key].wert\" key=\"key\" readonly=\"true\"></parametermodule></dd></dl>");;return buf.join("");
}